import { cn } from "@/lib/utils";

interface PreviewHintProps {
  children: React.ReactNode;
  className?: string;
}

export function PreviewHint({ children, className }: PreviewHintProps) {
  return (
    <div
      className={cn(
        "text-xs text-muted-foreground bg-muted/20 border border-border/60 rounded-md px-2 py-1 max-w-full break-words min-w-0",
        className
      )}
    >
      {children}
    </div>
  );
}
